module.exports = __webpack_public_path__ + "img/barcelona_el_poble_sec.ea1b77e7.jpg";